var errors = require('../../strings/errors.en.json');

const getAppErrors = errorCode => {
  const error = errors.find(({ code }) => errorCode === code);
  return error;
};

export default getAppErrors;
